<template>
    <layout-authenticated>
        <v-breadcrumbs :items="breadcrumb"></v-breadcrumbs>
        <h2>{{$t('users.warehouses_to_user_name', {name: this.user ? this.user.first_name + ' ' + this.user.last_name : ''}) }}</h2>
        <edit-users-to-warehouse-form v-if="user !== null" :user="user"/>
    </layout-authenticated>
</template>

<script>
import EditUsersToWarehouseForm from "@/components/admin/forms/EditUsersToWarehouseForm";
import {API} from "@/api/api";
import snackbarMixin from "@/mixins/SnackbarMixin";
import LayoutAuthenticated from "@/layouts/LayoutAuthenticated";

export default {
    name: "WarehousesToUser",
    mixins: [snackbarMixin],
    components: {LayoutAuthenticated, EditUsersToWarehouseForm},
    data: () => ({
        // loading
        isBusyUser: false,
        // data
        user: null
    }),
    computed: {
        userId() {
            return parseInt(this.$route.params.userId)
        },
        breadcrumb() {
            return [
                {
                    text: this.$t('app.administration'),
                    href: '/admin'
                },
                {
                    text: this.$t('users.users'),
                    href: '/admin/users',
                },
                {
                    text: this.$t('users.warehouses_to_user'),
                    href: '/admin/users/' + this.userId + '/warehouses',
                    disabled: true
                }
            ];
        }
    },
    methods: {
        fetchUser() {
            this.isBusyUser = true
            API.get("/api/users/" + this.userId)
                .then(response => {
                    this.user = response.data
                })
                .catch(error => {
                    this.snackbarError(error);
                })
                .finally(() => {
                    this.isBusyUser = false;
                })
        }
    },
    created() {
        this.fetchUser()
    }
}
</script>
